import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';
import icon from '../utils/icon';
import BrandVoteTotal from './BrandVoteTotal';
import { brandHref, groupLinkHref } from '../utils/manifest';
import { START_NAV_ICON, START_NAV_LABEL, TECHNICIAN_TOPICS_ICON, BRAND_NAV_ICON, isStartNavGroup, isTechnicianTopicsGroup } from '../utils/startNav';
export default class PresentationNav extends Component {
  view() {
    const {
      manifest
    } = this.attrs;
    const groups = manifest.groups || [];
    return m("div", {
      className: "FlatRatePresentationNav",
      role: "navigation",
      "aria-label": "Forum presentation navigation"
    }, m("ul", {
      className: "FlatRatePresentationNav-list"
    }, groups.map(group => this.renderGroup(group))));
  }
  renderGroup(group) {
    if (group.mode === 'link') {
      const start = isStartNavGroup(group);
      const technician = isTechnicianTopicsGroup(group);
      if (start && this.attrs.hideStart === true) {
        return null;
      }
      const linkIcon = start ? START_NAV_ICON : technician ? TECHNICIAN_TOPICS_ICON : null;
      return m("li", {
        className: `FlatRatePresentationNav-item FlatRatePresentationNav-item--link FlatRatePresentationNav-item--${group.id}`,
        key: group.id
      }, m(Link, {
        className: classList('FlatRatePresentationNav-link', {
          'FlatRatePresentationNav-link--start': start,
          'FlatRatePresentationNav-link--technician': technician,
          hasIcon: Boolean(linkIcon)
        }),
        href: groupLinkHref(group, this.attrs.manifest),
        force: true
      }, linkIcon ? icon(linkIcon) : null, start ? START_NAV_LABEL : group.label));
    }
    if (group.mode === 'tree' && group.id === 'brands') {
      return m("li", {
        className: "FlatRatePresentationNav-item FlatRatePresentationNav-item--brands",
        key: group.id
      }, m("ul", {
        className: "FlatRatePresentationNav-tree"
      }, (group.boards || []).map(board => this.renderBrandNode(board, 0))));
    }
    return null;
  }
  renderBrandNode(board, depth) {
    const children = Array.isArray(board.children) ? board.children : [];
    const hasChildren = children.length > 0;
    return m("li", {
      className: classList('FlatRatePresentationNav-brand', `depth-${depth}`, {
        'has-children': hasChildren
      }),
      key: board.boardKey
    }, m("div", {
      className: "FlatRatePresentationNav-row"
    }, m(Link, {
      className: classList('FlatRatePresentationNav-link', 'FlatRatePresentationNav-brandLink', 'hasIcon'),
      href: brandHref(board),
      force: true
    }, icon(BRAND_NAV_ICON), m("span", {
      className: "FlatRatePresentationNav-brandName"
    }, board.name), m(BrandVoteTotal, {
      board: board
    }))), hasChildren ? m("ul", {
      className: "FlatRatePresentationNav-children"
    }, children.map(child => this.renderBrandNode(child, depth + 1))) : null);
  }
}
flarum.reg.add('flatrate-forum-navigation', 'forum/components/PresentationNav', PresentationNav);